import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { Root } from "./routes/Root/Root";
import { PrivacyPolicy } from "./routes/PrivacyPolicy/PrivacyPolicy";
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
    gtmId: 'G-FESRWJNJ7D'
}

TagManager.initialize(tagManagerArgs)

// import ReactGA from 'react-ga';
// const TRACKING_ID = "G-FESRWJNJ7D"; // YOUR_OWN_TRACKING_ID
// ReactGA.initialize(TRACKING_ID);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
